import { Button, Col, Input, Row } from "antd";
import { useTranslation } from "react-i18next";
import { SelectTypeTransport } from "../../../../components/selects";
import { CloseOutlined, PlusCircleOutlined } from "@ant-design/icons";
import React, { useCallback, useEffect, useState } from "react";
import { TransportItem } from "../../../../models/transportItem";

interface IProps {
  setTransports: (transports: TransportItem[]) => void;
  transports: TransportItem[]|null;
}

export const MtsItems: React.FC<IProps> = ({ setTransports, transports }) => {
  const { t } = useTranslation();
  const [transportItems, setTransportItems] = useState<TransportItem[]>([]);

  // Функция для генерации уникального ключа
  const generateUniqueKey = (): number => {
	return Math.random();
  };

  // Создание нового элемента с уникальным ключом
  const createNewItem = (): TransportItem => ({
	key: generateUniqueKey(),
	id: null,
	transportTypeId: null,
	transportType: null,
	count: null,
  });

  useEffect(() => {
	if (transports && transports.length > 0) {
	  const itemsWithKeys = transports.map((item) => ({
		...item,
		key: item.key || generateUniqueKey(),
	  }));
	  setTransportItems(itemsWithKeys);
	} else {
	  setTransportItems([createNewItem()]);
	}
  }, []);

  useEffect(() => {
	setTransports(transportItems);
  }, [transportItems]);

  const handleAddItem = useCallback(() => {
	setTransportItems((prevItems) => [...prevItems, createNewItem()]);
  }, []);

  const handleDeleteItem = useCallback(
	(key: number) => {
	  if (transportItems.length > 1) {
		const updatedItems = transportItems.filter((item) => item.key !== key);
		setTransportItems(updatedItems);
		setTransports(updatedItems);
	  }
	},
	[transportItems, setTransports]
  );

  const handleInputChange = (
	key: number,
	field: keyof TransportItem,
	value: any
  ) => {
	const updatedContacts = transportItems.map((item) =>
	  item.key === key ? { ...item, [field]: value } : item
	);
	setTransportItems(updatedContacts);
  };

  const isFieldEmpty = (value: any) => {
	return value === null || value === undefined || value === "";
  };

  return (
	<div style={ { marginTop: 15 } }>
	  { transportItems.map((item) => (
		<div key={ item.id } className="block_item_form massive_blocks">
		  <Button
			type="primary"
			className="fixed_delete"
			danger
			icon={ <CloseOutlined/> }
			shape="circle"
			size="small"
			disabled={ transportItems.length === 1 }
			onClick={ () => handleDeleteItem(item.key as number) }
		  />
		  <Row style={ { margin: 0 } } gutter={ 16 }>
			<Col className="gutter-row" span={ 12 }>
			  <label>{ t("Транспорт") }</label>
			  <SelectTypeTransport
				value={ item.transportTypeId }
				status={ isFieldEmpty(item.transportTypeId) ? "error" : "" }
				onChange={ (value) =>
				  handleInputChange((item.key as number), "transportTypeId", value)
				}
			  />
			</Col>
			<Col className="gutter-row" span={ 12 }>
			  <label>{ t("Количество") }</label>
			  <Input
				type="number"
				className={ isFieldEmpty(item.count) ? "error-border" : "" }

				value={ item.count || "" }
				onChange={ (e) =>
				  handleInputChange((item.key as number), "count", Number(e.target.value))
				}
			  />
			</Col>
		  </Row>
		</div>
	  )) }
	  <Button
		style={ { marginTop: 15 } }
		icon={ <PlusCircleOutlined/> }
		type="primary"
		onClick={ handleAddItem }
	  >
		{ t("Добавить еще элемент") }
	  </Button>
	</div>
  );
};